import { gql } from 'graphql-request';
import {
  FinCategoryID,
  FinCategoryName,
  FinCategoryParentFinCategoryID,
  FinCategoryUUID
} from '../finCategoriesTypes';

export interface FetchFinCategoriesQueryResponse {
  id: FinCategoryID;
  uuid: FinCategoryUUID;
  name: FinCategoryName;
  parentFinCategoryId: FinCategoryParentFinCategoryID;
}

export const FETCH_FIN_CATEGORIES_QUERY = gql`
  query FinCategories(
    $filters: FinCategoryFilter
    $sort: [FinCategoriesSortEnum]
    $offset: Int
    $limit: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    finCategories(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        id
        uuid
        name
        parentFinCategoryId
      }
      paginationInfo {
        currentPage
        firstPage
        lastPage
        limitValue
        nextPage
        outOfRange
        prevPage
        totalCount
        totalPages
      }
      sql
    }
  }
`;
